export enum RouteName {
  BillingPortal = "AC_BillingPortal",
  CatalogAndPricing = "AC_CatalogAndPricingView",
  Clerks = "AC_Clerks",
  CreateMerchant = "AC_CreateMerchant",
  Dashboard = "AC_Dashboard",
  Home = "AC_Home",
  Login = "AC_LoginView",
  Merchants = "AC_Merchants",
  PartnerApi = "AC_PartnerApi",
  Reports = "AC_ReportsView",
  Settings = "AC_Settings",
}
